import { render, staticRenderFns } from "./Copyable.vue?vue&type=template&id=5b0e228e&scoped=true&"
import script from "./Copyable.vue?vue&type=script&lang=js&"
export * from "./Copyable.vue?vue&type=script&lang=js&"
import style0 from "./Copyable.vue?vue&type=style&index=0&id=5b0e228e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e228e",
  null
  
)

export default component.exports